// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"fa78d5a1","732":"013420da","977":"80579c0f"}[chunkId] + ".chunk.js");